import Header from '@/shared/components/Header';
import Footer from '@/shared/components/Footer';
import Head from "next/head";
import Templates from '@/widgets/index';
import { useState, useEffect } from 'react';
import styles from './styles.module.css';
import getDataLayer from '@/shared/functions/gtm';
import TagManager from 'react-gtm-module';
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';
import { useAppContext } from '@pagegrowler_nextjs';
import Chartbeat from '@/shared/components/Chartbeat';
import MetaTags from '@/shared/components/MetaTags';
import { formatAuthorNames } from '@/shared/functions/formatAthorNames'

import Twitter from '@/icons/components/Twitter'
import Instagram from '@/icons/components/Instagram';
import Facebook from '@/icons/components/Facebook';
import PagegrowlerList from '@/widgets/Listado/Templates/PagegrowlerList';

function Autor(props) {

  // estado booleano, para determinar si la data que se le envia a NotaDeSeccion, viene del servidor o del cliente
	const [conditionDataRender, setConditionDataRender] = useState(false);
  
  const LOAD_MORE = 12;
  const pg = useAppContext();

  const Pagegrowler = pg.pagegrowler;

  const author = props.properties
  const authorName = formatAuthorNames(author.name);

  const [open, setOpen] = useState(false);

  let [data, setData] = useState([]);
  let [offset, setOffset] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [hideLoadMore, setHideLoadMore] = useState(false);

  let menues = props.menu ? props.menu : [];

  // Funcion que regresa las propiedades de properties vacias o no, dependiendo de que properties exista o no.
  const handleValueProperties = () => {
      const valueDefaultProperties = {
        biography: "",
        category: "",
        email: "",
        gtmPublishedDate: "",
        hasVisiblePage: "",
        idImage: "",
        imageID: "",
        imageUrl: "",
        lastModified: "",
        modificatedAt: "",
        name: "",
        product: "",
        publishedDate: "",
        shortBiography: "",
        slug: "",
        twitter: "",
        type: "",
        _id: ""
    }

    const { properties } = { ...props }

    if (properties === undefined) {
      return valueDefaultProperties
    }

    return properties
  }

  const propertiesValue = handleValueProperties();
	propertiesValue.imageUrl = propertiesValue.imageUrl.replace('http://', 'https://');
  const {
    content,
    pagination = {},
    widgets
  } = { ...props };

  const description = `Noticias por autor de ${authorName} - Últimas Noticias actualizadas las 24hs.`;

  const gtmObject = {
    _id: propertiesValue._id,
    publishedDate: propertiesValue.publishedDate,
    page_type: 'sección',
    nsSite: propertiesValue.nsSite,
    gtm_name: propertiesValue.name,
  };

  async function showMoreData() {
    setIsLoading(true);
    let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
    if (res.content && res.content.length > 0) {
			setConditionDataRender(true);
      setData(prevState => [...prevState, ...res.content]);
      setOffset(offset + LOAD_MORE);
      setIsLoading(false);
    } else {
      setHideLoadMore(true);
    }
  }

  useEffect(() => {
    TagManager.dataLayer({ dataLayer: getDataLayer(gtmObject) });
    setOffset(pagination.limit + pagination.offset);
    setData(content);
  }, []);

  return (
    <>
      <Head>
        <title>
          {`Noticias por autor de ${authorName} - Últimas Noticias     : : El Litoral - Noticias - Santa Fe - Argentina - ellitoral.com : :
        `}</title>
        <meta name="author" content={`Noticias por autor de ${authorName} - Últimas Noticias     : : El Litoral - Noticias - Santa Fe - Argentina - ellitoral.com : :`} />
        <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <meta name="og:description" property="og:description" content={description}/>
        <meta name="title" content={`Noticias por autor de ${authorName}`}/>
        <meta name="description"  content={description}/>
        <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <meta httpEquiv="refresh" content="600" />
        <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + `/autor/${author.slug}`} />
        <MetaTags metas={props.meta} />
      </Head>
      <Chartbeat authors={author} />
      <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
      <div className={`${styles['parent']}`} itemScope itemType="https://schema.org/NewsArticle">
        <div className={`${styles['main-container']}`}>
          {!props.preview && <BannerHorizontalChico bannerId={'top'} />}
          <div className={`${styles['container']}`}>
            <div className={`${styles['detail-left']}`}>
              <div className={`${styles["author-container"]}`} itemProp="author" itemScope itemType="https://schema.org/Person">
                <a itemProp="url" className={`${styles["author-a"]}`} href={`/autor/${propertiesValue.slug}`}>
                  <img itemProp="image" loading="lazy" src={propertiesValue.imageUrl} alt={authorName ? authorName : "Imagen del Autor"}/>
                </a>
                <div className={`${styles["author-name"]}`}>
                  {author.name && <h1 itemProp="name">{authorName}</h1>}
                  <div className={`${styles["container-author-social-media"]}`}>
                  {author.email && <a href={`mailto:${author.email}`}>
                                      <div className={`${styles["autor-email-btn"]}`} >
                                        {author.email}
                                      </div>
                                    </a>}

                                    <div className={`${styles['container-icon-social-media']}`}>
                                      {author.twitter && <a href={author.twitter} target={"_blank"} rel='noreferrer noopener'>
                                          <div className={`${styles["icon-author-social-media"]} `}>
                                              <Twitter className={`${styles['icon']} ${styles["twitter-icon"]}`}/>
                                          </div>
                                        </a>}

                                      {author.facebook && <a href={author.facebook} target={"_blank"} rel='noreferrer noopener'>
                                          <div className={`${styles["icon-author-social-media"]} `}>
                                              <Facebook className={`${styles['icon']} ${styles['facebook-icon']}`}/>
                                          </div>
                                        </a>}

                                      {author.instagram && <a href={author.instagram} target={"_blank"} rel='noreferrer noopener'>
                                          <div className={`${styles["icon-author-social-media"]} `}>
                                              <Instagram className={`${styles['icon']}`}/>
                                          </div>
                                        </a>}
                                    </div>

                                   
                                   
                  </div>                 
                  {author.shortBiography && <p>{author.shortBiography}</p>}
                </div>
              </div>
              
                { author.biography && (
                    <>
                        <div
                            className={styles["author-biografia"]}
                            dangerouslySetInnerHTML={{
                                __html: author.biography
                            }}
                        />
                      
                    <div className={styles["separator"]}></div>
                        
                    </>
                )}
              {data && (
                <Templates.NotasDeAutor data={conditionDataRender ? data : content} />
              )}
              <div className={`${styles['btn-container']}`}>
                <button className={`${styles['button-load-more']} ${styles[hideLoadMore ? 'hide' : '']}`} disabled={isLoading} onClick={showMoreData}>
                  VER MÁS NOTAS
                </button>
              </div>
            </div>

            <div className={`${styles['detail-right']}`}>
              <PagegrowlerList url='column-lilanews'/>
            </div>
          </div>
          <div className={`${styles['detail-full']}`}>
            {!props.preview && <BannerHorizontalChico bannerId={'horizontal1'} />}
            <div className={`${styles['widget-block']}`}>
                <PagegrowlerList url='column-bottom-lilanews'/>
            </div> 

          </div>
        </div>

      </div>
      <div style={{ clear: 'both' }}>
        <Footer />
      </div>
    </>
  );
}

export default Autor;